import React, { memo } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import AdminSearchField from '../../../components/admin/AdminSearchField';
import { adminPageHeaderSx } from '../../../styles/adminComponentStyles';

type AccountHoldersHeaderProps = {
  search: string;
  onSearchChange: (value: string) => void;
};

const AccountHoldersHeader: React.FC<AccountHoldersHeaderProps> = ({ search, onSearchChange }) => (
  <Box sx={adminPageHeaderSx}>
    <Typography className="AdminPageHeader-title">Users Account Holder</Typography>
    <Stack direction="row" spacing={1.5} sx={{ width: { xs: '100%', md: 'auto' } }}>
      <AdminSearchField
        placeholder="Search users"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        sx={{ width: { xs: '100%', md: 300 } }}
        inputProps={{ 'aria-label': 'Search users' }}
      />
    </Stack>
  </Box>
);

export default memo(AccountHoldersHeader);
